import { Badge } from "@mantine/core";
import { useTranslation } from "react-i18next";

const COLOR_MAP: Record<string, string> = {
  open: "gray",
  pending: "gray",
  in_progress: "blue",
  pending_chief: "orange",
  completed: "blue",
  cancelled: "red",
  revoked: "red",
  healthy: "blue",
  unhealthy: "red",
  restricted_fit: "orange",
  unfit_for_work: "red",
  paid: "blue",
  unpaid: "orange",
  partial: "blue",
  active: "blue",
  inactive: "gray",
};

export function StatusBadge({
  status,
  i18nPrefix,
  size = "sm",
}: {
  status: string;
  i18nPrefix?: string;
  size?: "xs" | "sm" | "md" | "lg";
}) {
  const { t } = useTranslation();
  const color = COLOR_MAP[status] ?? "gray";
  const label = i18nPrefix ? t(`${i18nPrefix}.${status}`) : status;
  return (
    <Badge color={color} variant="light" size={size}>
      {label}
    </Badge>
  );
}
